// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__TQ4xB","label":"Radio_label__B5AMe","checkMark":"Radio_checkMark__mwgwk","disabled":"Radio_disabled__7NWLC"};